<script>

	import Layout from '@/layouts/layoutA'
	import Masthead from '@/layouts/layoutA/masthead'
	import FormLayout from '@/layouts/FormLayout'
	import FreeTrialForm from '@/components/FreeTrialForm'

	const SecondaryInfo = () => (
		<ul class="secondary-info">
			<li>
				<p><a target="_blank" href="https://www.imaginelearning.com/about/contact-us">Contact Imagine Learning</a> for more information about StudySync ELA.</p>
				<p>
					Imagine Learning LLC 
					<br />100 S Mill Ave. Suite 1700, 
					<br />Tempe, AZ 85281
				</p>
			</li>
			<li>
				<p>If you are a McGraw Hill StudySync user, please <a href="https://content.studysync.com/support/05/StudySyncMcGrawPartnershipFAQ.pdf">click here</a> to receive support on the below questions and more—FAQ, Tech or platform support​, Requests for more materials, Requests for training​, Questions/concerns about your StudySync product, My StudySync subscriptions are about to expire. I want to renew, and I need help!​</p>
			</li>
		</ul>
	)

	export default {
		metaInfo () {
			return this.$generateMetaInfo({
				title: `StudySync Free Trial`,
				description: `Start using our products today. Sign up for a free trial for StudySync ELA, SyncBlasts, or StudySync Global and watch your classroom light up.`,
				image: 'https://www.studysync.com/static/img/contact.370898e.jpg'
			})
		},
		render () {
			return (
				<Layout mastheadBackgroundImage={require('img/mastheads/contact.jpg')}>
					<div slot="masthead" class="center">
						<Masthead>
							<template slot="headline">Sign Up For a Free Trial Today</template>
							<template slot="content">Sign up and watch your classroom light up!</template>
						</Masthead>
					</div>
					{this.$route.query.v === 'form' ? (
						<div class="content" slot="body">
							<FormLayout>
								<div class="content__info" slot="info">
									<SecondaryInfo />
								</div>
								<div class="layout__form" slot="form">
									<FreeTrialForm />
								</div>
							</FormLayout>
						</div>
					) : (
						<div class="content--old" slot="body">
							<div class="content__secondary">
								<h2>Contact Us</h2>
								<SecondaryInfo />
							</div>
							<div class="content__primary">
								<h2>Get your Free Trial Today</h2>
								<ul class="trial-links">
									<li class="trial-item">
										<div class="trial-item__figure">
											<figure>
												<img src={require('@/assets/img/ela/video-group/1.jpg')} />
											</figure>
											<div class="trial-item__overlay">
												<div class="nav__title">StudySync<mark>ELA</mark></div>
												<h5 class="trial-item__title">Deliver Inspiration With Your ELA Curriculum.</h5>
												<btn><a href="https://www.imaginelearning.com/about/contact-us/" target="_blank">StudySync ELA Free Trial</a></btn>
											</div>
										</div>
									</li>
									<li class="trial-item">
										<div class="trial-item__figure">
											<figure>
												<img src={require('@/assets/img/ela/video-group/2.jpg')} />
											</figure>
											<div class="trial-item__overlay">
												<div class="nav__title">Sync<mark>Blasts</mark></div>
												<h5 class="trial-item__title">Boost science engagement with inquiry-based SyncBlasts.</h5>
												<btn><a href="https://www.imaginelearning.com/about/contact-us/" target="_blank">Science SyncBlasts Free Trial</a></btn>
											</div>
										</div>
										{/* <div class="trial-item__prompt">
											<p><a href="https://www.mheducation.com/prek-12/program/microsites/MKTSP-ROA01M0/syncblasts.html" target="_blank">Learn more</a> about McGraw Hill's<br />SyncBlasts offering.</p>
										</div> */}
									</li>
								</ul>
								<ul class="trial-links">
									<li class="trial-item">
										<div class="trial-item__figure">
											<figure>
												<img src={require('@/assets/img/ela/video-group/1.jpg')} />
											</figure>
											<div class="trial-item__overlay">
												<div class="nav__title">StudySync<mark>Global</mark></div>
												<h5 class="trial-item__title">A curriculum designed for international middle and high schools.</h5>
												<btn><a href="https://www.imaginelearning.com/about/contact-us/" target="_blank">StudySync Global Trial</a></btn>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					)}
				</Layout>
			)
		}
	}
</script>

<style lang="scss" scoped>

	@import "responsive-font";
	@import "list-style-reset";
	@import "media";
	@import "container";

	.content {
		@include responsive-font(10);
		@include media(small,xlarge) {
			background:#F6F8F9; padding-bottom:3em;
			& > * {
				padding-top:3em;
			}
		}
		@include media(xlarge) {
			& > * {
				background:#F6F8F9;
			}
		}
	}

	.content--old {
		@include responsive-font(10);
		display:flex;

		@include media(small,xlarge) {
			@include container;
			background:#F6F8F9; padding-bottom:3em;
			& > * {
				padding-top:3em;
			}
		}
		@include media(small) {
			flex-direction:column-reverse;
		}

		@include media(xlarge) {
			flex-direction:row; align-items:left;
			& > * {
				background:#F6F8F9; padding:6em;
			}

			.content__primary {
				flex:1;
			}

			.content__secondary {
				flex:0 0 percentage(1/3);
			}
		}

		h2 {
			@include responsive-font(40);
			text-transform: uppercase; line-height: 1.1; font-weight:400; margin-bottom:.75em;
		}

		.nav {
			@include container;
			display:flex; justify-content:space-between; border-bottom:1px solid rgba(#09253B, .12);
			&__title {
				@include responsive-font(25);
				text-transform:uppercase; font-family:"Oswald"; font-weight:400; color:#fff; line-height:1.28; margin:.3rem 0 .6rem;
				mark {
					color:#FDB913; display:inline-block;
				}
			}
		}

		.trial-links {
			@include list-style-reset;
			margin: 1em 0;
			@include media(large) {
				display: flex; flex-direction: row;

				.trial-item + .trial-item {
					margin-left:3rem;
				}
			}

			.trial-item {

				@include media(large) {
					width:50%;
				}

				&__figure {
					position:relative;
				}

				&__overlay {
					position:absolute; top:0; bottom:0; left:0; right:0; background:linear-gradient(rgba(#000, 0) 10%, rgba(#000, 1)); color:#fff; display:flex; align-items:center; flex-direction:column; justify-content:flex-end; padding:0 3em 1.5em; text-align:center;
				}

				&__title {
					@include responsive-font(18);
					font-family:"oswald", sans-serif; font-weight:400; text-transform:uppercase; line-height:1.66; margin: 0 0 .75em 0;
				}

				&__prompt {
					@include responsive-font(14);
					position:relative; line-height: 1.5; font-weight:400; margin-bottom:3em; opacity:.75; margin-top:.75em;

					p > a {
						color:inherit;
					}
				}
			}

		}

	}

	.secondary-info {
		@include list-style-reset;
		@include responsive-font(18);
		color:#6D6E71;
		li + li {
			margin-top:2em;
		}
		h4 {
			@include responsive-font(12);
			font-family:'proxima-nova'; font-weight:600; letter-spacing:.075em; text-transform:uppercase; color:#FDB913;
		}
		p {
			margin:.25em 0 0;
		}
		a {
			color:inherit;
		}
	}

</style>



// WEBPACK FOOTER //
// src/routes/free-trial/index.vue